(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection_grid_glass"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pgrid-section').forEach(function (section) {
    if (section.dataset.pgridInit === 'true') return;
    section.dataset.pgridInit = 'true';

    var filters = section.querySelectorAll('.pgrid-filter');
    var cards = section.querySelectorAll('.pgrid .pcard');
    if (!filters.length) return;

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-filter');

        filters.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        cards.forEach(function (card) {
          var show = value === '__all' || card.getAttribute('data-type') === value;
          card.classList.toggle('is-filtered-out', !show);
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SUPPORTS_POINTER = typeof window.PointerEvent !== 'undefined';

    function nowMs() {
      return (window.performance && performance.now) ? performance.now() : Date.now();
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function mountImages(root, track) {
      if (root.dataset.defer !== 'true') return;

      var swapped = false;
      function swap() {
        if (swapped) return;
        swapped = true;
        track.querySelectorAll('img[data-src]').forEach(function (img) {
          if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
          img.setAttribute('src', img.dataset.src);
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        });
      }

      if (!('IntersectionObserver' in window)) {
        swap();
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            io.disconnect();
            swap();
          }
        },
        { rootMargin: '800px 0px' }
      );
      io.observe(root);
    }

    function shuffleTrack(track, passes) {
      var kids = [].slice.call(track.children);
      var n = kids.length / passes;
      if (n < 2 || n % 1 !== 0) return;

      var set = kids.slice(0, n);
      for (var i = set.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = set[i]; set[i] = set[j]; set[j] = tmp;
      }

      var frag = document.createDocumentFragment();
      set.forEach(function (el) { frag.appendChild(el); });
      for (var p = 1; p < passes; p++) {
        set.forEach(function (el) {
          var copy = el.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          frag.appendChild(copy);
        });
      }

      track.innerHTML = '';
      track.appendChild(frag);
    }

    function initInfiniteCarousel(root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var track = root.querySelector('.infinite-carousel__track');
      if (!track) return;

      // Orden aleatorio: barajamos el primer set y reconstruimos las 3 copias
      // idénticas, para que el bucle infinito siga sin costuras.
      if (root.dataset.shuffle === 'true') shuffleTrack(track, 3);

      // Las fotos no se piden hasta que el carrusel se acerca. En la portada
      // esta sección es la última: si pidiera sus imágenes desde el primer
      // momento —como hacía— se llevaría el ancho de banda que necesitan las
      // fotos de los productos, que están más arriba y se ven antes.
      mountImages(root, track);

      // ----- Ajustes -----
      // mode: 'always' | 'pause_hover' | 'drag'
      var mode = root.dataset.mode || 'drag';
      var speedDesktop = parseFloat(root.dataset.speed) || 3;
      var speedMobile = parseFloat(root.dataset.speedMobile) || speedDesktop;
      var direction = root.dataset.direction === 'right' ? 1 : -1;

      // "Inercia" 1..10 -> fricción por frame (más alto = se desliza más lejos)
      var inertiaSetting = parseFloat(root.dataset.inertia);
      if (!(inertiaSetting >= 1 && inertiaSetting <= 10)) inertiaSetting = 6;
      var FRICTION = 0.900 + inertiaSetting * 0.008; // 0.908 .. 0.980

      var MAX_VELOCITY = 90;   // px por frame
      var DRAG_EASE = 0.30;    // suavizado dedo/mouse -> sensación "liquid"
      var SETTLE_EASE = 0.20;
      var AUTO_EASE = 0.045;   // rampa suave al arrancar/pausar el automático

      // ----- Estado -----
      var setWidth = 0;
      var position = 0;   // lo que se pinta
      var target = 0;     // a dónde queremos llegar (drag)
      var velocity = 0;   // inercia del arrastre, px por frame
      var autoCurrent = 0; // velocidad automática actual (rampa)

      var isDragging = false;
      var isHovering = false;
      var pointerId = null;
      var startX = 0;
      var startPos = 0;
      var lastX = 0;
      var lastMoveTime = 0;

      var rafId = null;
      var lastFrame = 0;
      var started = false;

      function autoSpeed() {
        if (mode === 'drag') return 0;
        if (isDragging) return 0;
        if (mode === 'pause_hover' && isHovering) return 0;
        var s = isMobileViewport() ? speedMobile : speedDesktop;
        return s * 0.5 * direction;
      }

      function measure() {
        var prev = setWidth;
        setWidth = track.scrollWidth / 3;
        if (prev > 0 && setWidth > 0) {
          var ratio = setWidth / prev;
          position *= ratio;
          target *= ratio;
          startPos *= ratio;
        }
        wrap();
        render();
      }

      function wrap() {
        if (setWidth <= 0) return;
        var shift = 0;
        while (position + shift <= -setWidth * 2) shift += setWidth;
        while (position + shift > 0) shift -= setWidth;
        if (shift !== 0) {
          position += shift;
          target += shift;
          startPos += shift;
        }
      }

      function render() {
        track.style.transform = 'translate3d(' + position.toFixed(2) + 'px,0,0)';
      }

      function frame(t) {
        var dt = lastFrame ? Math.min(64, t - lastFrame) : 16.67;
        lastFrame = t;
        var k = dt / 16.67;

        // Rampa suave del movimiento automático (arranca/pausa sin tirones)
        var wanted = autoSpeed();
        autoCurrent += (wanted - autoCurrent) * (1 - Math.pow(1 - AUTO_EASE, k));
        if (Math.abs(autoCurrent - wanted) < 0.005) autoCurrent = wanted;

        var moved = false;

        if (isDragging) {
          position += (target - position) * (1 - Math.pow(1 - DRAG_EASE, k));
          moved = true;
        } else {
          if (Math.abs(velocity) > 0.03) {
            position += velocity * k;
            velocity *= Math.pow(FRICTION, k);
            target = position;
            moved = true;
          } else {
            velocity = 0;
            if (Math.abs(target - position) > 0.05) {
              position += (target - position) * (1 - Math.pow(1 - SETTLE_EASE, k));
              moved = true;
            } else {
              position = target;
            }
          }

          if (Math.abs(autoCurrent) > 0.002) {
            position += autoCurrent * k;
            target = position;
            moved = true;
          }
        }

        if (moved) {
          wrap();
          render();
        }

        // Si no queda nada por animar, dormimos el loop (modo arrastre)
        if (!moved && !isDragging && autoCurrent === 0 && wanted === 0) {
          rafId = null;
          if (hinted) {
            track.style.willChange = '';
            hinted = false;
          }
          return;
        }

        rafId = requestAnimationFrame(frame);
      }

      /* La capa de memoria de vídeo se pide justo antes de moverse y se
         suelta al pararse. Mantenerla siempre es lo que hacía que en
         celular, con la memoria justa, el navegador tirase capas ya
         dibujadas y hubiera que volver a pintarlas. */
      var hinted = false;

      function play() {
        if (rafId === null) {
          if (!hinted) {
            track.style.willChange = 'transform';
            hinted = true;
          }
          lastFrame = 0;
          rafId = requestAnimationFrame(frame);
        }
      }

      function pointFrom(e) {
        if (e.touches && e.touches.length) return e.touches[0].clientX;
        if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
        return e.clientX;
      }

      function onDown(e) {
        if (typeof e.button === 'number' && e.button !== 0) return;
        if (isDragging) return;
        // El botón se pulsa, no se arrastra.
        if (e.target && e.target.closest && e.target.closest('.infinite-carousel__cta')) return;

        isDragging = true;
        root.classList.add('is-dragging');

        if (SUPPORTS_POINTER && e.pointerId != null) {
          pointerId = e.pointerId;
          if (root.setPointerCapture) {
            try { root.setPointerCapture(pointerId); } catch (err) {}
          }
        }

        var x = pointFrom(e);
        startX = x;
        lastX = x;
        startPos = position;
        target = position;
        velocity = 0;
        lastMoveTime = nowMs();
        play();
      }

      function onMove(e) {
        if (!isDragging) return;
        if (pointerId != null && e.pointerId != null && e.pointerId !== pointerId) return;

        var x = pointFrom(e);
        target = startPos + (x - startX);

        var t = nowMs();
        var dt = t - lastMoveTime;
        if (dt > 0) {
          var instant = ((x - lastX) / dt) * 16.67;
          velocity = velocity * 0.72 + instant * 0.28;
          if (velocity > MAX_VELOCITY) velocity = MAX_VELOCITY;
          if (velocity < -MAX_VELOCITY) velocity = -MAX_VELOCITY;
          lastX = x;
          lastMoveTime = t;
        }
        play();
      }

      function onUp() {
        if (!isDragging) return;
        isDragging = false;
        root.classList.remove('is-dragging');

        if (pointerId != null && root.releasePointerCapture) {
          try { root.releasePointerCapture(pointerId); } catch (err) {}
        }
        pointerId = null;

        // Si el dedo/mouse se quedó quieto antes de soltar, no lanzamos inercia
        if (nowMs() - lastMoveTime > 110) velocity = 0;
        target = position;
        play();
      }

      if (SUPPORTS_POINTER) {
        root.addEventListener('pointerdown', onDown);
        root.addEventListener('pointermove', onMove);
        root.addEventListener('pointerup', onUp);
        root.addEventListener('pointercancel', onUp);
        window.addEventListener('pointerup', onUp);
      } else {
        root.addEventListener('mousedown', onDown);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
        root.addEventListener('touchstart', onDown, { passive: true });
        root.addEventListener('touchmove', onMove, { passive: true });
        root.addEventListener('touchend', onUp);
        root.addEventListener('touchcancel', onUp);
      }

      root.addEventListener('mouseenter', function () { isHovering = true; play(); });
      root.addEventListener('mouseleave', function () { isHovering = false; play(); });

      // Trackpad / rueda horizontal
      root.addEventListener('wheel', function (e) {
        var dx = e.deltaX;
        if (Math.abs(dx) <= Math.abs(e.deltaY)) return; // scroll vertical: no lo tocamos
        e.preventDefault();
        target = position - dx;
        velocity = 0;
        play();
      }, { passive: false });

      track.querySelectorAll('img').forEach(function (img) {
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });

      if (typeof unfOnResize === 'function') {
        unfOnResize(measure);
      } else {
        window.addEventListener('resize', measure);
      }

      // Pausa cuando la pestaña no está visible (ahorra batería y evita saltos)
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
        } else if (started) {
          play();
        }
      });

      function start() {
        if (started) return;
        started = true;
        measure();
        position = -setWidth; // arrancamos en la copia del medio
        target = position;
        render();
        play();
      }

      var imgs = track.querySelectorAll('img');
      if (imgs.length === 0) {
        start();
      } else {
        var loaded = 0;
        imgs.forEach(function (img) {
          function done() {
            loaded++;
            if (loaded >= imgs.length) start();
          }
          if (img.complete) done();
          else {
            img.addEventListener('load', done);
            img.addEventListener('error', done);
          }
        });
        setTimeout(start, 600); // fallback por si alguna imagen tarda
      }
    }

    function initAll() {
      document.querySelectorAll('.infinite-carousel').forEach(initInfiniteCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.infinite-carousel');
      if (el) initInfiniteCarousel(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (function () {
    // Version en JS del filtro "handle" de Liquid: minusculas, sin tildes/ene
    // y separado por guiones. Tiene que dar el mismo resultado que el handle
    // que ya trae cada pestana en "data-cf-tab", para poder comparar el tipo
    // que llega por la URL (?tipo=Pantalones) contra ellas.
    function toHandle(str) {
      return (str || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function initCollectionFilter(root) {
      if (root.dataset.cfInit === 'true') return;
      root.dataset.cfInit = 'true';

      var scope = root.closest('.product-grid-container') || document;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cf-tab]'));
      // El aviso de "no hay productos" vive fuera de la barra, en la cabecera.
      var empty = (root.closest('.cf-head') || root).querySelector('[data-cf-empty]');
      var row = root.querySelector('[data-cf-row]');
      var indicator = root.querySelector('[data-cf-indicator]');
      var viewport = root.querySelector('[data-cf-viewport]');
      // Los ajustes de la fila de pestanas viven en el elemento .plf, que
      // puede no existir si no hay pestanas que mostrar. El resto de la barra
      // (panel de filtros y columnas) funciona igual sin el.
      var plfEl = root.querySelector('.plf');
      var stagger = parseFloat(getComputedStyle(plfEl || root).getPropertyValue('--plf-stagger')) || 0;
      var current = root.getAttribute('data-cf-initial') || '*';

      // Si se llega con "?tipo=Pantalones" en la URL (por ejemplo, desde un
      // enlace del menu que apunte a /collections/all?tipo=Pantalones), esa
      // pestana arranca seleccionada, sin recargar nada: es la misma pagina
      // de siempre, solo que ya filtrada. Si el tipo de la URL no calza con
      // ninguna pestana de las que hay aqui, se ignora y se deja el valor de
      // siempre.
      try {
        var urlType = new URLSearchParams(window.location.search).get('tipo');
        if (urlType) {
          var wantedHandle = toHandle(urlType);
          var matchesTabList = tabs.some(function (t) {
            return t.getAttribute('data-cf-tab') === wantedHandle;
          });
          if (matchesTabList) current = wantedHandle;
        }
      } catch (e) {
        // Navegadores muy viejos sin URLSearchParams: se deja el valor de
        // siempre, no rompe nada.
      }

      // Panel de filtros: talla, color y orden. Lo elegido no se aplica hasta
      // pulsar APLICAR, igual que en el panel de referencia.
      var head = root.closest('.cf-head');
      var panel = head ? head.querySelector('[data-cf-panel]') : null;
      var openBtn = head ? head.querySelector('[data-cf-open]') : null;
      var backdrop = head ? head.querySelector('[data-cf-backdrop]') : null;
      var backdropTimer = null;
      var activeDot = head ? head.querySelector('[data-cf-active-dot]') : null;
      var order = [];
      var sel = { sizes: [], colors: [], sort: '' };
      var draft = { sizes: [], colors: [], sort: '' };
      var observer = null;
      var lastClick = 0;
      var shuffleOnTab = root.getAttribute('data-cf-shuffle-on-tab') === 'true';

      // Vuelve a barajar el orden "base" al que sortGrid() regresa en cada
      // apply(). Sin esto, sortGrid() siempre restaura el mismo "order"
      // guardado y el catalogo se veria igual aunque se llame a apply() de
      // nuevo. Solo se usa si la seccion tiene el orden aleatorio activado.
      function shuffleOrder() {
        var list = order.length ? order.slice() : items().slice();
        for (var i = list.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = list[i];
          list[i] = list[j];
          list[j] = tmp;
        }
        order = list;
      }

      // La carga automatica puede reemplazar la cuadricula entera, asi que se
      // vuelve a buscar cada vez en lugar de guardarla una sola vez.
      function getGrid() {
        return scope.querySelector('.product-grid');
      }

      function copy(o) {
        return { sizes: o.sizes.slice(), colors: o.colors.slice(), sort: o.sort };
      }

      function has(list, v) {
        return list.indexOf(v) > -1;
      }

      function toggle(list, v) {
        var i = list.indexOf(v);
        if (i > -1) list.splice(i, 1);
        else list.push(v);
      }

      function items() {
        return Array.prototype.slice.call(scope.querySelectorAll('[data-cf-item]'));
      }

      // Indicador deslizante: se coloca encima de la pestana activa.
      function moveIndicator(tab, animate) {
        if (!indicator || !tab) return;
        if (!animate) indicator.style.transition = 'none';
        indicator.style.width = tab.offsetWidth + 'px';
        indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
        indicator.classList.add('is-ready');
        if (!animate) {
          void indicator.offsetWidth;
          indicator.style.transition = '';
        }
      }

      function hasKey(item, attr, key) {
        return (item.getAttribute(attr) || '').indexOf('|' + key + '|') > -1;
      }

      function matchesTab(item, key) {
        if (key === '*') return true;
        return hasKey(item, 'data-cf-keys', key);
      }

      // Basta con que el producto tenga una de las tallas marcadas, y una de
      // los colores marcados. Entre grupos distintos se exige que cumpla todos.
      function matchesAny(item, attr, list) {
        if (!list.length) return true;
        for (var i = 0; i < list.length; i++) {
          if (hasKey(item, attr, list[i])) return true;
        }
        return false;
      }

      function matches(item, key) {
        if (!matchesTab(item, key)) return false;
        if (!matchesAny(item, 'data-cf-sizes', sel.sizes)) return false;
        if (!matchesAny(item, 'data-cf-colors', sel.colors)) return false;
        // "Novedades" no reordena: deja solo lo etiquetado como nuevo.
        if (sel.sort === 'new' && !hasKey(item, 'data-cf-keys', 'nuevo')) return false;
        return true;
      }

      function counts() {
        var list = items();
        tabs.forEach(function (tab) {
          var counter = tab.querySelector('[data-cf-count]');
          if (!counter) return;
          var key = tab.getAttribute('data-cf-tab');
          var n = 0;
          list.forEach(function (item) {
            if (matchesTab(item, key)) n++;
          });
          counter.textContent = '(' + n + ')';
        });
      }

      // Ordena de verdad: mueve las tarjetas dentro de la cuadricula. Se
      // guarda el orden original para poder volver a el.
      function sortGrid() {
        var grid = getGrid();
        if (!grid) return;
        var list = items();
        if (!order.length) order = list.slice();

        var target;
        if (sel.sort === 'price-asc' || sel.sort === 'price-desc') {
          target = list.slice().sort(function (a, b) {
            var pa = parseFloat(a.getAttribute('data-cf-price')) || 0;
            var pb = parseFloat(b.getAttribute('data-cf-price')) || 0;
            return sel.sort === 'price-asc' ? pa - pb : pb - pa;
          });
        } else {
          target = order.filter(function (el) {
            return el.isConnected;
          });
          list.forEach(function (el) {
            if (target.indexOf(el) === -1) target.push(el);
          });
        }

        // Si ya estan en ese orden no se toca el DOM: mover tarjetas dispara
        // al observador y reinicia las animaciones sin necesidad.
        var same = list.length === target.length;
        if (same) {
          for (var i = 0; i < target.length; i++) {
            if (list[i] !== target[i]) {
              same = false;
              break;
            }
          }
        }
        if (same) return;

        // Se apaga el observador mientras se reordena. Su aviso llega despues,
        // no en el momento, asi que una bandera no bastaria: se volveria a
        // llamar a si mismo sin parar.
        if (observer) observer.disconnect();

        var frag = document.createDocumentFragment();
        target.forEach(function (el) {
          frag.appendChild(el);
        });
        grid.appendChild(frag);

        if (observer) watchGrid();
      }

      function apply(key, animate) {
        current = key;
        var shown = 0;

        if (!order.length) order = items().slice();
        sortGrid();

        items().forEach(function (item) {
          if (matches(item, key)) {
            item.removeAttribute('data-cf-hidden');
            // El retardo en cascada se cuenta solo sobre las que quedan a la
            // vista, para que no haya huecos de tiempo.
            item.style.setProperty('--plf-delay', stagger * shown + 'ms');
            shown++;
            if (animate) {
              item.classList.remove('plf-in');
              void item.offsetWidth;
              item.classList.add('plf-in');
            }
          } else {
            item.setAttribute('data-cf-hidden', '');
            item.classList.remove('plf-in');
          }
        });

        if (empty) empty.hidden = shown > 0;

        tabs.forEach(function (t) {
          var on = t.getAttribute('data-cf-tab') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) moveIndicator(t, animate);
        });

        if (activeDot) {
          activeDot.hidden = !(sel.sizes.length || sel.colors.length || sel.sort);
        }
      }

      // ---------- Panel de filtros ----------
      function paintDraft() {
        if (!panel) return;
        panel.querySelectorAll('[data-cf-size]').forEach(function (b) {
          b.classList.toggle('is-active', has(draft.sizes, b.getAttribute('data-cf-size')));
        });
        panel.querySelectorAll('[data-cf-color]').forEach(function (b) {
          b.classList.toggle('is-active', has(draft.colors, b.getAttribute('data-cf-color')));
        });
        panel.querySelectorAll('[data-cf-sort]').forEach(function (r) {
          r.checked = draft.sort === r.value;
        });
      }

      function closePanel() {
        if (!panel || panel.hidden) return;
        panel.hidden = true;
        // Por si quedo a medio arrastrar.
        panel.classList.remove('is-dragging');
        panel.style.transform = '';
        panel.style.opacity = '';
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        hideBackdrop();
      }

      // El fondo difuminado se monta y se desmonta con el panel. Primero se
      // muestra sin opacidad y en el cuadro siguiente se enciende, si no el
      // navegador se salta la transicion.
      function showBackdrop() {
        if (!backdrop) return;
        if (backdropTimer) {
          clearTimeout(backdropTimer);
          backdropTimer = null;
        }
        backdrop.hidden = false;
        window.requestAnimationFrame(function () {
          backdrop.classList.add('is-visible');
        });
      }

      function hideBackdrop() {
        if (!backdrop || backdrop.hidden) return;
        backdrop.classList.remove('is-visible');
        var wait = parseFloat(getComputedStyle(backdrop).transitionDuration) * 1000 || 0;
        backdropTimer = setTimeout(function () {
          backdrop.hidden = true;
          backdropTimer = null;
        }, wait);
      }

      if (panel && openBtn) {
        // La capa se cuelga del <body>. Si se quedara dentro de la seccion, un
        // ancestro con transform o container-type la ataria a esa caja y
        // dejaria de cubrir la ventana entera.
        if (backdrop) {
          var stamp = 'cf-backdrop-' + (root.closest('.shopify-section') || {}).id;
          if (stamp) {
            var prev = document.querySelector('[data-cf-backdrop][data-cf-owner="' + stamp + '"]');
            if (prev && prev !== backdrop) prev.remove();
            backdrop.setAttribute('data-cf-owner', stamp);
          }
          // Las variables viven en la cabecera; al mudarse hay que llevarselas.
          if (head) {
            var cs = getComputedStyle(head);
            ['--cf-backdrop-blur', '--cf-backdrop-dim', '--cf-backdrop-speed'].forEach(function (v) {
              var value = cs.getPropertyValue(v);
              if (value) backdrop.style.setProperty(v, value.trim());
            });
          }
          document.body.appendChild(backdrop);
          backdrop.addEventListener('click', closePanel);
        }

        openBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = panel.hidden;
          if (open) {
            draft = copy(sel);
            paintDraft();
          }
          panel.hidden = !open;
          openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) {
            // Punto de partida para el cierre por desplazamiento.
            scrollAnchor = window.scrollY;
            showBackdrop();
          } else {
            hideBackdrop();
          }
        });

        // Salir del panel es facil a proposito. Solo los cuadros retienen la
        // pulsacion: el hueco entre ellos, el aire de los lados y todo lo de
        // fuera cierran.
        panel.addEventListener('click', function (e) {
          if (e.target.closest('.cf-panel__card, .cf-panel__actions, .cf-panel__top')) {
            e.stopPropagation();
            return;
          }
          closePanel();
        });

        // Cruz de cerrar.
        var closeBtn = panel.querySelector('[data-cf-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            closePanel();
          });
        }

        // Al desplazar la pagina un buen trecho el panel estorba, asi que se
        // retira solo. El margen evita que lo cierre el pequeno salto que da
        // el navegador al abrir el teclado o al rebotar en el borde.
        var scrollAnchor = 0;
        window.addEventListener(
          'scroll',
          function () {
            if (panel.hidden) {
              scrollAnchor = window.scrollY;
              return;
            }
            if (Math.abs(window.scrollY - scrollAnchor) > 140) closePanel();
          },
          { passive: true }
        );

        // En el celular tambien se cierra arrastrandolo hacia abajo, como una
        // hoja: se sigue el dedo y si baja lo suficiente (o se suelta rapido)
        // se va; si no, vuelve a su sitio.
        var grab = panel.querySelector('[data-cf-grab]');
        if (grab && window.PointerEvent) {
          var swipeY = 0;
          var swipeT = 0;
          var swiping = false;

          grab.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse') return;
            if (e.target.closest('[data-cf-close]')) return;
            swiping = true;
            swipeY = e.clientY;
            swipeT = Date.now();
            panel.classList.add('is-dragging');
          });

          grab.addEventListener(
            'pointermove',
            function (e) {
              if (!swiping) return;
              var dy = e.clientY - swipeY;
              if (dy < 0) dy = 0;
              panel.style.transform = 'translateY(' + dy + 'px)';
              panel.style.opacity = String(Math.max(0.4, 1 - dy / 260));
            },
            { passive: true }
          );

          ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
            grab.addEventListener(evt, function (e) {
              if (!swiping) return;
              swiping = false;
              panel.classList.remove('is-dragging');
              var dy = Math.max(0, (e.clientY || swipeY) - swipeY);
              var fast = Date.now() - swipeT < 260 && dy > 24;
              panel.style.transform = '';
              panel.style.opacity = '';
              if (dy > 70 || fast) closePanel();
            });
          });
        }

        // Cambiar de tamano de ventana recoloca todo: mejor cerrarlo.
        unfOnResize(closePanel);

        document.addEventListener('click', closePanel);

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closePanel();
        });

        panel.querySelectorAll('[data-cf-size]').forEach(function (b) {
          b.addEventListener('click', function () {
            toggle(draft.sizes, b.getAttribute('data-cf-size'));
            paintDraft();
          });
        });

        panel.querySelectorAll('[data-cf-color]').forEach(function (b) {
          b.addEventListener('click', function () {
            toggle(draft.colors, b.getAttribute('data-cf-color'));
            paintDraft();
          });
        });

        panel.querySelectorAll('[data-cf-sort]').forEach(function (r) {
          r.addEventListener('click', function () {
            // El navegador marca el radio por su cuenta; quien manda es
            // draft.sort. Volver a pulsar la opcion ya elegida la desmarca.
            var now = Date.now();
            if (now - lastClick < 60) return;
            lastClick = now;
            draft.sort = draft.sort === r.value ? '' : r.value;
            paintDraft();
          });
        });

        var applyBtn = panel.querySelector('[data-cf-apply]');
        if (applyBtn) {
          applyBtn.addEventListener('click', function () {
            sel = copy(draft);
            if (shuffleOnTab) shuffleOrder();
            apply(current, true);
            closePanel();
          });
        }

        var resetBtn = panel.querySelector('[data-cf-reset]');
        if (resetBtn) {
          resetBtn.addEventListener('click', function () {
            draft = { sizes: [], colors: [], sort: '' };
            sel = copy(draft);
            paintDraft();
            if (shuffleOnTab) shuffleOrder();
            apply(current, true);
          });
        }
      }

      // ---------- Productos por fila ----------
      var densBtns = head ? Array.prototype.slice.call(head.querySelectorAll('[data-cf-cols]')) : [];
      densBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var cols = b.getAttribute('data-cf-cols');
          var box = scope.classList && scope.classList.contains('product-grid-container') ? scope : null;
          if (box) {
            box.setAttribute('data-cf-cols', cols);
            box.style.setProperty('--cf-cols', cols);
          }
          densBtns.forEach(function (o) {
            o.classList.toggle('is-active', o === b);
          });
        });
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-cf-tab');
          if (shuffleOnTab) shuffleOrder();
          // Aunque la pestana ya estuviera seleccionada, se vuelve a lanzar la
          // animacion de entrada: el toque siempre responde con algo.
          apply(key, true);
          if (row && row.scrollWidth > row.clientWidth) {
            var target = tab.offsetLeft - row.clientWidth / 2 + tab.offsetWidth / 2;
            target = Math.max(0, Math.min(target, row.scrollWidth - row.clientWidth));
            if (row.scrollTo) {
              row.scrollTo({ left: target, behavior: 'smooth' });
            } else {
              row.scrollLeft = target;
            }
          }
        });
      });

      // Marca en que direcciones queda recorrido, para difuminar ese borde.
      function updateEdges() {
        if (!viewport || !row) return;
        var max = row.scrollWidth - row.clientWidth;
        var x = row.scrollLeft;
        viewport.classList.toggle('can-scroll-left', x > 2);
        viewport.classList.toggle('can-scroll-right', x < max - 2);
      }

      if (row) {
        row.addEventListener('scroll', updateEdges, { passive: true });
        unfOnResize(updateEdges);
        updateEdges();

        // En escritorio la fila tambien se arrastra con el mouse; en movil el
        // desplazamiento del dedo ya funciona solo.
        var dragging = false;
        var startX = 0;
        var startLeft = 0;
        var moved = 0;

        row.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse') return;
          dragging = true;
          moved = 0;
          startX = e.clientX;
          startLeft = row.scrollLeft;
        });

        row.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var delta = e.clientX - startX;
          if (Math.abs(delta) > 4) {
            moved = Math.abs(delta);
            row.classList.add('is-dragging');
            e.preventDefault();
            row.scrollLeft = startLeft - delta;
          }
        });

        ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
          row.addEventListener(evt, function () {
            dragging = false;
            setTimeout(function () {
              row.classList.remove('is-dragging');
            }, 0);
          });
        });

        row.addEventListener(
          'click',
          function (e) {
            if (moved > 6) {
              e.preventDefault();
              e.stopPropagation();
              moved = 0;
            }
          },
          true
        );
      }

      counts();
      apply(current, root.getAttribute('data-cf-animate-load') === 'true');

      // El catalogo va paginado y puede ir trayendo mas productos solo: cada
      // vez que aparecen tarjetas nuevas hay que volver a aplicar la pestana
      // que este puesta, o entrarian sin filtrar. Solo interesan las altas de
      // tarjetas: cualquier otro cambio dentro de una tarjeta (una foto que
      // rota, un panel que se abre) se ignora.
      function bringsCards(records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.hasAttribute('data-cf-item') || n.querySelector('[data-cf-item]')) return true;
          }
        }
        return false;
      }

      function watchGrid() {
        var grid = getGrid();
        if (!observer || !grid) return;
        observer.observe(grid, { childList: true });
      }

      if (window.MutationObserver) {
        var pending = false;
        observer = new MutationObserver(function (records) {
          if (pending || !bringsCards(records)) return;
          pending = true;
          window.requestAnimationFrame(function () {
            pending = false;
            // Las tarjetas nuevas se anaden al final del orden original.
            items().forEach(function (el) {
              if (order.indexOf(el) === -1) order.push(el);
            });
            counts();
            apply(current, false);
          });
        });
        watchGrid();
      }

      // Las medidas del indicador dependen de la tipografia ya cargada y del
      // ancho de la ventana: se recolocan al terminar de cargar y al cambiar
      // de tamano.
      function reposition() {
        moveIndicator(root.querySelector('.plf__tab.is-active'), false);
      }

      window.addEventListener('load', function () {
        reposition();
        updateEdges();
      });
      unfOnResize(reposition);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(reposition);
      }
    }

    // Barra de filtros deslizable: en el celular las pestanas, el boton de
    // filtros y los botones de columnas van en una sola fila que se corre hacia
    // los lados. El dedo la desplaza solo; aqui se anade el arrastre con el
    // mouse y el aviso de que queda recorrido a un lado.
    function initFilterRail(rail) {
      if (!rail || rail.dataset.cfRailInit === 'true') return;
      rail.dataset.cfRailInit = 'true';

      var wrap = rail.closest('[data-cf-rail-wrap]');

      function updateEdges() {
        if (!wrap) return;
        var max = rail.scrollWidth - rail.clientWidth;
        // Sin recorrido (escritorio, o pocas pestanas) no se pinta nada.
        if (max <= 2) {
          wrap.classList.remove('can-scroll-left', 'can-scroll-right');
          return;
        }
        var x = rail.scrollLeft;
        wrap.classList.toggle('can-scroll-left', x > 2);
        wrap.classList.toggle('can-scroll-right', x < max - 2);
      }

      rail.addEventListener('scroll', updateEdges, { passive: true });
      unfOnResize(updateEdges);
      window.addEventListener('load', updateEdges);
      updateEdges();

      var dragging = false;
      var startX = 0;
      var startLeft = 0;
      var moved = 0;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        // El panel de filtros trae sus propios controles: si el arrastre
        // empieza dentro, no se toca.
        if (e.target.closest('[data-cf-panel]')) return;
        dragging = true;
        moved = 0;
        startX = e.clientX;
        startLeft = rail.scrollLeft;
      });

      rail.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var delta = e.clientX - startX;
        if (Math.abs(delta) > 4) {
          moved = Math.abs(delta);
          rail.classList.add('is-dragging');
          e.preventDefault();
          rail.scrollLeft = startLeft - delta;
        }
      });

      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
        rail.addEventListener(evt, function () {
          dragging = false;
          setTimeout(function () {
            rail.classList.remove('is-dragging');
          }, 0);
        });
      });

      // Soltar tras arrastrar no debe contar como pulsar la pestana de debajo.
      rail.addEventListener(
        'click',
        function (e) {
          if (moved > 6) {
            e.preventDefault();
            e.stopPropagation();
            moved = 0;
          }
        },
        true
      );

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(updateEdges);
      }
    }

    function run() {
      document.querySelectorAll('[data-cf]').forEach(initCollectionFilter);
      document.querySelectorAll('[data-cf-rail]').forEach(initFilterRail);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    // El editor de temas vuelve a pintar la seccion al cambiar un ajuste.
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFilter(root) {
      if (root.dataset.plfInit === 'true') return;
      root.dataset.plfInit = 'true';

      // La seccion entera: las tarjetas viven fuera de la barra, y si hay
      // carrusel en movil estan duplicadas, asi que se filtran las dos copias.
      var section = root.closest('.section-resource-list') || root.parentElement;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-plf-tab]'));

      var empty = root.querySelector('[data-plf-empty]');
      var row = root.querySelector('[data-plf-row]');
      var indicator = root.querySelector('[data-plf-indicator]');
      var viewport = root.querySelector('[data-plf-viewport]');
      var shuffleOnTab = root.getAttribute('data-plf-shuffle-on-tab') === 'true';
      // Cuando el orden aleatorio esta prendido, no solo se filtra por tipo:
      // ademas se limita a "maxVisible" productos por pestana (el resto de
      // los que coinciden se quedan afuera hasta el proximo barajado). Sin
      // esto, al usar los filtros aparecerian TODOS los que coincidan con el
      // tipo (que pueden ser muchos mas de los que la seccion deberia
      // mostrar), en vez de solo el grupo del tamano configurado.
      var maxVisible = parseInt(root.getAttribute('data-plf-max-visible'), 10) || 0;
      // La lista arranca oculta con CSS (ver stylesheet, mismo mecanismo que
      // usa el barajado inicial) hasta el primer apply(): recien ahi se sabe
      // de verdad cuales productos quedan a la vista.
      var plrList = section.querySelector('[data-plr-randomize]');

      // Se usa solo para el conteo por pestana (no para elegir que se
      // muestra: eso ahora lo hace apply() directamente, ver mas abajo).
      function getItems() {
        return Array.prototype.slice.call(section.querySelectorAll('[data-plf-item]'));
      }
      var stagger = parseFloat(getComputedStyle(root).getPropertyValue('--plf-stagger')) || 0;

      // Indicador deslizante: se coloca encima de la pestana activa. Va dentro
      // de la fila, asi que las medidas son relativas al contenido y siguen
      // siendo validas aunque la fila se haya desplazado a los lados.
      function moveIndicator(tab, animate) {
        if (!indicator || !tab) return;
        if (!animate) indicator.style.transition = 'none';
        indicator.style.width = tab.offsetWidth + 'px';
        indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
        indicator.classList.add('is-ready');
        if (!animate) {
          void indicator.offsetWidth;
          indicator.style.transition = '';
        }
      }

      function matches(item, key) {
        if (key === '*') return true;
        return (item.getAttribute('data-plf-keys') || '').indexOf('|' + key + '|') > -1;
      }

      function apply(key, animate) {
        // Todo el trabajo — barajar, elegir el cupo y acomodar el DOM — se
        // hace ACA, de una sola vez, cada vez que se llama apply(). Antes
        // esto estaba partido en dos pasos separados (un shuffleItems() que
        // movia las tarjetas, y este apply() que despues elegia el cupo
        // leyendo el DOM ya movido): sonaba bien pero el barajado mezclaba
        // TODAS las tarjetas de la seccion (coincidan o no con la pestana),
        // mientras que el cupo se sacaba solo de las que coinciden — con
        // pocas tarjetas de por medio, ese doble filtro terminaba sacando
        // agrupamientos muy parecidos una y otra vez, aunque el orden en
        // pantalla si se viera distinto. Ahora se baraja UNICAMENTE el grupo
        // que coincide con la pestana actual, y el cupo sale directo de ese
        // barajado: cada click es un sorteo fresco sobre lo que de verdad
        // puede aparecer en esta pestana.
        var lists = Array.prototype.slice.call(section.querySelectorAll('.resource-list'));
        var shown = 0;

        lists.forEach(function (list) {
          var listItems = Array.prototype.slice.call(list.querySelectorAll(':scope > [data-plf-item]'));
          var matching = [];
          var rest = [];
          listItems.forEach(function (item) {
            (matches(item, key) ? matching : rest).push(item);
          });

          if (shuffleOnTab && matching.length > 1) {
            for (var i = matching.length - 1; i > 0; i--) {
              var j = Math.floor(Math.random() * (i + 1));
              var tmp = matching[i];
              matching[i] = matching[j];
              matching[j] = tmp;
            }
          }

          var shownList = maxVisible > 0 ? matching.slice(0, maxVisible) : matching;
          var restOfMatching = maxVisible > 0 ? matching.slice(maxVisible) : [];

          // Las que se muestran quedan primero en el DOM, ya en su orden al
          // azar: asi el navegador pide sus fotos en fila (como en el
          // catalogo) y no en el orden en que se fueron moviendo.
          var frag = document.createDocumentFragment();
          shownList.forEach(function (item) {
            frag.appendChild(item);
          });
          restOfMatching.forEach(function (item) {
            frag.appendChild(item);
          });
          rest.forEach(function (item) {
            frag.appendChild(item);
          });
          list.appendChild(frag);

          shownList.forEach(function (item) {
            item.removeAttribute('data-plf-hidden');
            // El retardo en cascada se cuenta solo sobre las que quedan a la
            // vista, para que no haya huecos de tiempo.
            item.style.setProperty('--plf-delay', stagger * shown + 'ms');
            shown++;
            if (animate) {
              item.classList.remove('plf-in');
              // Reinicia la animacion para que se note el cambio de pestana.
              void item.offsetWidth;
              item.classList.add('plf-in');
            }
          });
          restOfMatching.concat(rest).forEach(function (item) {
            item.setAttribute('data-plf-hidden', '');
            item.classList.remove('plf-in');
          });
        });

        if (empty) empty.hidden = shown > 0;

        tabs.forEach(function (t) {
          var on = t.getAttribute('data-plf-tab') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) moveIndicator(t, animate);
        });

        // Recien ahora, con el primer filtrado/recorte ya hecho, se marca
        // la lista como lista para mostrarse (ver stylesheet): asi solo se
        // pinta una vez, ya con el grupo final.
        if (plrList) plrList.setAttribute('data-plr-done', 'true');
      }

      // Cuenta de productos por pestana, calculada sobre lo que hay en pantalla
      // (asi no se descuadra si cambia el limite de productos).
      tabs.forEach(function (tab) {
        var counter = tab.querySelector('[data-plf-count]');
        if (!counter) return;
        var key = tab.getAttribute('data-plf-tab');
        // Con carrusel en movil las tarjetas estan duplicadas: se cuentan las
        // que hay en la cuadricula, no las copias del carrusel.
        var grid = section.querySelector('.resource-list:not(.hidden--desktop)');
        var pool = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-plf-item]')) : getItems();
        var n = 0;
        pool.forEach(function (item) {
          if (matches(item, key)) n++;
        });
        counter.textContent = '(' + n + ')';
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-plf-tab');
          // apply() ya baraja y elige el cupo de nuevo cada vez que se
          // llama (ver mas arriba), asi que un solo llamado alcanza.
          // Aunque la pestana ya estuviera seleccionada, se vuelve a lanzar la
          // animacion de entrada: el toque siempre responde con algo.
          apply(key, true);
          // Deja la pestana pulsada a la vista cuando la fila se desliza.
          if (row && row.scrollWidth > row.clientWidth) {
            var target = tab.offsetLeft - row.clientWidth / 2 + tab.offsetWidth / 2;
            target = Math.max(0, Math.min(target, row.scrollWidth - row.clientWidth));
            if (row.scrollTo) {
              row.scrollTo({ left: target, behavior: 'smooth' });
            } else {
              row.scrollLeft = target;
            }
          }
        });
      });

      // Si se quito "Ver todo", al cargar ya se muestra solo el primer tipo.
      // Marca en que direcciones queda recorrido, para difuminar ese borde.
      function updateEdges() {
        if (!viewport || !row) return;
        var max = row.scrollWidth - row.clientWidth;
        var x = row.scrollLeft;
        viewport.classList.toggle('can-scroll-left', x > 2);
        viewport.classList.toggle('can-scroll-right', x < max - 2);
      }

      if (row) {
        row.addEventListener('scroll', updateEdges, { passive: true });
        unfOnResize(updateEdges);
        updateEdges();

        // En escritorio la fila tambien se puede arrastrar con el mouse; en
        // movil el desplazamiento nativo del dedo ya funciona solo.
        var dragging = false;
        var startX = 0;
        var startLeft = 0;
        var moved = 0;

        row.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse') return;
          dragging = true;
          moved = 0;
          startX = e.clientX;
          startLeft = row.scrollLeft;
        });

        row.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var delta = e.clientX - startX;
          if (Math.abs(delta) > 4) {
            moved = Math.abs(delta);
            row.classList.add('is-dragging');
            e.preventDefault();
            row.scrollLeft = startLeft - delta;
          }
        });

        ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
          row.addEventListener(evt, function () {
            dragging = false;
            setTimeout(function () {
              row.classList.remove('is-dragging');
            }, 0);
          });
        });

        row.addEventListener(
          'click',
          function (e) {
            if (moved > 6) {
              e.preventDefault();
              e.stopPropagation();
              moved = 0;
            }
          },
          true
        );
      }

      var initial = root.getAttribute('data-plf-initial') || '*';
      // Al cargar, la animacion de entrada se puede reproducir igual que al
      // cambiar de pestana.
      apply(initial, root.getAttribute('data-plf-animate-load') === 'true');

      // Las medidas del indicador dependen de la tipografia ya cargada y del
      // ancho de la ventana: se recolocan al terminar de cargar y al cambiar
      // de tamano.
      function reposition() {
        var current = root.querySelector('.plf__tab.is-active');
        moveIndicator(current, false);
      }

      window.addEventListener('load', function () {
        reposition();
        updateEdges();
      });
      unfOnResize(reposition);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(reposition);
      }
    }

    function run() {
      document.querySelectorAll('[data-plf]').forEach(initFilter);
    }

    run();
    // El editor de temas vuelve a pintar la seccion al cambiar un ajuste.
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productos-recomendados"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Las recomendaciones de Shopify llegan por su propia ruta: se le pide esta
    // misma seccion ya renderizada y nos quedamos solo con la cuadricula, asi
    // las tarjetas son identicas a las del catalogo.
    function init(root) {
      if (root.dataset.prcInit === 'true') return;
      root.dataset.prcInit = 'true';

      if (root.getAttribute('data-prc-mode') !== 'auto') return;

      var grid = root.querySelector('[data-prc-grid]');
      var empty = root.querySelector('[data-prc-empty]');
      var productId = root.getAttribute('data-prc-product');

      // Ya venian pintadas (por ejemplo al recargar dentro del editor).
      if (grid && grid.children.length) {
        root.hidden = false;
        return;
      }

      if (!grid || !productId) {
        if (empty) {
          empty.hidden = false;
          root.hidden = false;
        }
        return;
      }

      var url =
        root.getAttribute('data-prc-url') +
        '?section_id=' + root.getAttribute('data-prc-section') +
        '&product_id=' + productId +
        '&limit=' + (root.getAttribute('data-prc-limit') || 4) +
        '&intent=' + (root.getAttribute('data-prc-intent') || 'related');

      fetch(url)
        .then(function (r) {
          return r.ok ? r.text() : Promise.reject(r.status);
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var incoming = parsed.querySelector('[data-prc-grid]');
          var items = incoming ? incoming.children.length : 0;

          if (items) {
            grid.innerHTML = incoming.innerHTML;
            if (empty) empty.hidden = true;
            root.hidden = false;
            // Las tarjetas recien puestas necesitan que se monte su panel de
            // tallas y sus flechas: el bloque de la tarjeta escucha este aviso.
            document.dispatchEvent(new CustomEvent('unf:cards-added'));
          } else if (empty) {
            empty.hidden = false;
            root.hidden = false;
          }
        })
        .catch(function () {
          /* Sin recomendaciones: la seccion se queda fuera de la pagina. */
        });
    }

    function run() {
      document.querySelectorAll('[data-prc]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vistos-recientemente"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'unf:recently-viewed';
    var MOBILE = '(max-width: 749px)';
    var DIMS = ['width', 'height', 'min-width', 'min-height', 'max-width', 'max-height'];

    function readHandles() {
      try {
        var raw = window.localStorage.getItem(KEY);
        if (!raw) return [];
        var list = JSON.parse(raw);
        if (!Array.isArray(list)) return [];
        // Solo cadenas: si quedo algo viejo guardado con otro formato, se ignora.
        return list.filter(function (h) {
          return typeof h === 'string' && h.length > 0;
        });
      } catch (e) {
        return [];
      }
    }

    // Ultima palabra sobre el tamano de los circulos: un estilo en linea con
    // !important esta por encima de cualquier hoja de estilos del tema. La
    // medida no se inventa aqui: se lee de las variables que publica el bloque
    // de precio de la propia tarjeta, asi que manda lo que este configurado en
    // ese bloque desde el editor.
    function sizeSwatches(root) {
      var isMobile = window.matchMedia(MOBILE).matches;
      var boxes = root.querySelectorAll('.qsh-swatches');
      if (!boxes.length) return;

      boxes.forEach(function (box) {
        var cs = window.getComputedStyle(box);
        var size = cs.getPropertyValue(isMobile ? '--qsh-swatch-size-mobile' : '--qsh-swatch-size').trim();
        var gap = cs.getPropertyValue('--qsh-swatch-gap').trim();

        if (!size) size = isMobile ? '9px' : '14px';
        if (!gap) gap = '5px';

        box.style.setProperty('display', 'flex', 'important');
        box.style.setProperty('flex-wrap', 'wrap', 'important');
        box.style.setProperty('align-items', 'center', 'important');
        box.style.setProperty('gap', gap, 'important');

        Array.prototype.forEach.call(box.children, function (dot) {
          DIMS.forEach(function (prop) {
            dot.style.setProperty(prop, size, 'important');
          });
          dot.style.setProperty('flex', '0 0 auto', 'important');
          dot.style.setProperty('padding', '0', 'important');
          dot.style.setProperty('margin', '0', 'important');
          dot.style.setProperty('box-sizing', 'border-box', 'important');
        });
      });
    }

    function sizeAll() {
      document.querySelectorAll('[data-rvp]').forEach(sizeSwatches);
    }

    // Si algun script del tema vuelve a montar las tarjetas, se les fija el
    // tamano otra vez. Solo se vigilan altas y bajas de nodos, no atributos,
    // asi que escribir estilos aqui no se muerde la cola.
    function watch(root, grid) {
      if (!window.MutationObserver || root.dataset.rvpWatch === 'true') return;
      root.dataset.rvpWatch = 'true';

      var pending = false;
      var obs = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          sizeSwatches(root);
        });
      });

      obs.observe(grid, { childList: true, subtree: true });
    }

    function init(root) {
      if (root.dataset.rvpInit === 'true') return;
      root.dataset.rvpInit = 'true';

      var grid = root.querySelector('[data-rvp-grid]');
      var clear = root.querySelector('[data-rvp-clear]');
      var limit = parseInt(root.getAttribute('data-rvp-limit'), 10) || 4;
      var sectionId = root.getAttribute('data-rvp-section');
      var exclude = root.getAttribute('data-rvp-exclude') || '';

      if (clear) {
        clear.addEventListener('click', function () {
          try {
            window.localStorage.removeItem(KEY);
          } catch (e) {
            /* nada que hacer */
          }
          root.hidden = true;
        });
      }

      if (!grid) return;

      watch(root, grid);

      var handles = readHandles()
        .filter(function (h) {
          // En la ficha de un producto no se le recomienda ese mismo producto.
          return h !== exclude;
        })
        .slice(0, limit);

      if (!handles.length) return;

      var root_url =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      // Una peticion por producto, pero se pintan en el orden pedido: lo ultimo
      // visto primero.
      Promise.all(
        handles.map(function (handle) {
          return fetch(root_url + 'products/' + handle + '?section_id=' + sectionId)
            .then(function (r) {
              return r.ok ? r.text() : '';
            })
            .catch(function () {
              return '';
            });
        })
      ).then(function (chunks) {
        var found = 0;

        chunks.forEach(function (html) {
          if (!html) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var tpl = parsed.querySelector('template[data-rvp-card]');
          if (!tpl) return;

          var card = tpl.content.querySelector('.resource-list__item');
          if (!card) return;

          var item = document.importNode(card, true);

          // Las muestras de color viajan aparte: se cuelgan del precio, que es
          // donde van en el resto de la tienda.
          var swatchBox = tpl.content.querySelector('[data-rvp-swatches] .qsh-swatches');
          if (swatchBox) {
            var price = item.querySelector('product-price');
            var host = price || item;
            host.appendChild(document.importNode(swatchBox, true));
          }

          grid.appendChild(item);
          found++;
        });

        if (found) {
          root.hidden = false;
          if (clear) clear.hidden = false;
          sizeSwatches(root);
          // Las tarjetas recien puestas necesitan que se monte su panel de
          // tallas y sus flechas: el bloque de la tarjeta escucha este aviso.
          document.dispatchEvent(new CustomEvent('unf:cards-added'));
          sizeSwatches(root);
        }
      });
    }

    function run() {
      document.querySelectorAll('[data-rvp]').forEach(init);
      sizeAll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    // Al cruzar el corte de movil hay que volver a medir.
    unfOnResize(sizeAll);
    window.addEventListener('orientationchange', sizeAll, { passive: true });
    document.addEventListener('unf:cards-added', sizeAll);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
